<template>
  <div class="works-filter__tags" style="max-width: 100%;flex: auto;">
    <tag-item-sub
      v-for="(tag) in tags"
      v-bind:tag="tag"
    ><!-- v-bind:key - не указывать, т.к. он может повторяться. Например год -->
    </tag-item-sub>
  </div>
</template>

<script>
    import TagItemSub from "./TagItemSub";
    import WorksTagsMix from "../../../../components/list/WorksTagsMix";

    export default {
      components: {TagItemSub},
      name      : 'works-tags-sub',
      mixins: [WorksTagsMix],
    }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/WorksTagsSub.vue